import request from '@/utils/request'

export function getLicenses() {
  return request({
    url: '/licenses/1',
    method: 'get'
  })
}
export function getOEMInfo() {
  return request({
    url: '/licenses/oem',
    method: 'get'
  })
}
export function getLicenseStamp() {
  return request({
    url: '/licenses/1/stamp',
    method: 'get'
  })
}
